import { createClient } from '@supabase/supabase-js';

// 从环境变量读取配置
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// 调试信息：检查环境变量是否被正确读取
if (import.meta.env.DEV) {
  console.log('🔍 环境变量检查:');
  console.log('  VITE_SUPABASE_URL:', supabaseUrl || '❌ 未设置');
  console.log('  VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? `✅ 已设置 (${supabaseAnonKey.length} 字符)` : '❌ 未设置');
  console.log('  当前工作目录:', import.meta.url);
}

// 环境变量验证
if (!supabaseUrl) {
  console.error('❌ 错误: VITE_SUPABASE_URL 未设置');
  console.error('   请在项目根目录创建 .env.local 文件，并添加:');
  console.error('   VITE_SUPABASE_URL=https://your-project-id.supabase.co');
  console.error('   VITE_SUPABASE_ANON_KEY=your-anon-key-here');
  console.error('   文件路径应该是: ' + import.meta.url.replace(/\/src\/lib\/supabaseClient\.ts.*$/, '/.env.local'));
}

if (!supabaseAnonKey) {
  console.error('❌ 错误: VITE_SUPABASE_ANON_KEY 未设置');
}

// 环境变量格式验证
if (supabaseUrl && !supabaseUrl.endsWith('.supabase.co')) {
  console.warn('⚠️ 警告: VITE_SUPABASE_URL 格式可能不正确，应该以 .supabase.co 结尾');
  console.warn('当前值:', supabaseUrl);
}

// 初始化客户端，它是连接云端数据库的唯一通道
// 如果环境变量未设置，使用占位符避免应用崩溃（会在运行时检查）
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key'
);

// 导出检查函数（用于检查配置状态）
export const isSupabaseConfigured = () => {
  const isValid = !!(supabaseUrl && supabaseAnonKey && supabaseUrl.endsWith('.supabase.co'));
  if (!isValid) {
    if (!supabaseUrl) {
      console.error('❌ Supabase URL 未配置');
    } else if (!supabaseAnonKey) {
      console.error('❌ Supabase Anon Key 未配置');
    } else if (!supabaseUrl.endsWith('.supabase.co')) {
      console.error('❌ Supabase URL 格式不正确（应该以 .supabase.co 结尾）');
    }
  }
  return isValid;
};

